import { FormInstance } from 'antd';
import { selectSelectedCompanyName } from 'app/containers/Company/slice/selectors';
import { useSelector } from 'react-redux';
import { randomIntFromInterval } from 'utils/helpers';

const generateFieldName = (companyName: string) => {
  return `${companyName} ${randomIntFromInterval(1, 9999)
    .toString()
    .padStart(4, '0')}`;
};

export const useGenerateFieldNames = (form: FormInstance) => {
  const selectedCompanyName = useSelector(selectSelectedCompanyName);

  const generateFieldNames = () => {
    const values = form.getFieldsValue();

    const generatedFieldNames: { [key: string]: string } = {};

    Object.entries(values).forEach(([id, name]) => {
      if (!name || (typeof name === 'string' && !name.trim().length)) {
        generatedFieldNames[id] = generateFieldName(selectedCompanyName);
      }
    });

    form.setFieldsValue(generatedFieldNames);
  };

  return { generateFieldNames };
};
